<template>
  <div>
    <div class="my-3">
      <v-icon color="warning">mdi mdi-alert-outline </v-icon>
      <b> لطفا ابتدا پرداخت های ناموفق خود را تعیین تکلیف کنید.</b>
    </div>

    <v-data-table
      :items="paymentForRetrayPay"
      :headers="headers"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:no-data>
        <p>جدول خالی است</p>
      </template>
      <template v-slot:[`item.payRequestTimeUtc`]="{ item }">
        {{ item.payRequestTimeUtc | moment }}
      </template>
      <template v-slot:[`item.amount`]="{ item }">
        {{ item.amount.amount | priceSplitter }}
      </template>
      <template v-slot:[`item.currency`]="{ item }">
        {{ item.amount.currency }}
      </template>
      <template v-slot:[`item.operation`]="{ item }">
        <v-btn icon color="primary" @click="retryPaymentRequest(item)">
          <v-icon>mdi mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon color="error" @click="cancelPayment(item)">
          <v-icon>mdi mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const paymentRepository = () => RepoFactory.get('payment');
import Helper from '@/core/helpers';
export default {
  props: {
    paymentForRetrayPay: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      headers: [
        { sortable: true, text: 'زمان پرداخت', value: 'payRequestTimeUtc' },
        { sortable: true, text: ' عنوان', value: 'paymentMethodTitle' },
        { sortable: true, text: ' نوع', value: 'sourceTypeDisplayName' },
        { sortable: true, text: 'مبلغ', value: 'amount' },
        { sortable: true, text: 'واحد پول', value: 'currency' },
        { sortable: true, text: 'توضیحات', value: 'description' },
        {
          text: 'عملیات',
          value: 'operation',
        },
      ],
    };
  },
  methods: {
    getPaymentForRetrayPay() {
      this.$emit('getPaymentForRetrayPay');
    },
    cancelPayment(item) {
      this.$dialog.warning({
        text: ` آیا از لغو  <span class="red--text">${item.paymentMethodTitle} </span> اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              paymentRepository()
                .cancelPayment(
                  item.paymentCoreId,
                  this.$store.getters.paymentBaseUrl,
                  {
                    Authorization:
                      'Bearer ' + localStorage.getItem('access_token'),
                  }
                )
                .then((data) => {
                  this.$dialog.message.success('با موفقیت لغو گردید', {
                    position: 'top-left',
                  });
                  this.getPaymentForRetrayPay();
                })
                .catch((err) => {
                  Helper.handleErrors(err, this);
                });
            },
          },
        },
      });
    },
    retryPaymentRequest(item) {
      this.$dialog.warning({
        text: ` آیا از تکرار  <span class="red--text">${item.paymentMethodTitle} </span> اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              this.$emit('openFormForRetryRequest', item);
            },
          },
        },
      });
    },
  },
};
</script>

<style></style>
